import React, {useState, useEffect} from "react";
import Header from "./include/header";
import Footer from "./include/footer";
import UserLeftPanel from "./include/UserLeftPanel";
import Global from "../APIConfig";
import  axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../AuthUser";
import { useNavigate } from 'react-router-dom';

function HomePageBanner(){
    let navigate = useNavigate();
    const{headers1,headers2,logout}=AuthUser();
    const [title, setTitle] = useState('');
    const [url, setUrl] = useState('');
    const [detail, setDetail] = useState('');
    const [loading, setloading] = useState(false);
    const [bannerimg, setBannerimg] = useState('');

    useEffect(()=>{
    },[]);
    
    const handleSubmit=()=>{
        if(bannerimg==""){
            toast.warning('Banner is Required');
        }
        else{
            setloading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'AddHomePageBanner',
                headers:headers2,
                data: {
                    title:title,
                    detail:detail,
                    bannerimage:bannerimg,
                    url:url,
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                    setTimeout(() => {
                        navigate('/HomePageBannerList');
                      }, 1000);
                }else{
                    toast.warning(response.data.message);
                }
                setloading(false);
              })
              .catch(function (error) {
                setloading(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
              });
        }
    }
    return(
        <>
            <UserLeftPanel/>
            <main className='home-section'>
                <Header/>
                <ToastContainer/>
                <section className="left_sub_menu">
                <div className="row">
                    <div className="col-12 col-md">
                        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                            <div className="d-block mb-4 mb-md-0">
                                <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                    <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                        <li className="breadcrumb-item">
                                            <a href="/Admin-Dash">
                                            <i className="bx bx-home text-primary-400 fs-6"></i>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">Add Home Banner</li>
                                    </ol>
                                </nav>
                                <div className="d-flex justify-content-between">
                                    <div className="">
                                        <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                        <i className="bx bx-arrow-back "></i>
                                        </button>
                                    </div>
                                    <div className="ps-2 ">
                                        <h2 className="h4">Add Home Banner</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-toolbar mb-2 mb-md-0">
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                            <h6>Add Home Banner</h6>
                                <div className="row">
                                    <div className="col-12 mb-3 mt-4">
                                        <div className="row">
                                            <div className="col-6 mb-3">
                                                <label for="" className="form-label">Title: <small className="text-danger">(Enter total 40 Characters)</small></label>
                                                <input type="text" className="form-control" onChange={(e)=>setTitle(e.target.value)} placeholder="Please Enter Title" />
                                            </div>
                                            <div className="col-6 mb-3">
                                                <label for="" className="form-label">Detail: <small className="text-danger">(Enter total 110 Characters)</small></label>
                                                <input type="text" className="form-control" onChange={(e)=>setDetail(e.target.value)} placeholder="Please Enter detail" />
                                            </div>
                                            <div className="col-6 mb-3">
                                                <label for="" className="form-label">Image: <span className="text-danger">*</span></label>
                                                <input type="file" className="form-control" onChange={(e)=>setBannerimg(e.target.files[0])} placeholder="Please Select File" />
                                            </div>
                                            <div className="col-6 mb-3">
                                                <label for="" className="form-label">URL:</label> <small className="text-danger">(Always add a '/' before the page name when redirecting within the site.)</small>
                                                <input type="text" className="form-control" onChange={(e)=>setUrl(e.target.value)} placeholder="Please Select File" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {loading==false?
                                    <div className="d-grid col-md-2 mt-2">
                                        <button className="btn btn-primary" onClick={()=>handleSubmit()}>Submit</button>
                                    </div>
                                    :
                                    <div className="d-grid col-md-2 mt-2">
                                        <a href="" className="btn btn-primary btn-block"> <div class="spinner-border text-light" role="status"><span class="visually-hidden">Loading...</span></div></a>
                                    </div>
                                    }
                            </div>
                        </div>

                    </div>
                </div>
            </section>
                <Footer/>
            </main>
        </>
    )
}
export default HomePageBanner;